<div class="form-field">
  @if (label()) {
    <label class="form-label" [for]="id()">
      {{ label() }}

      @if (!readonly() && required()) {
        <span class="required">*</span>
      }
    </label>
  }

  <ng-content />
  @if (hintAfter()) {
    <p class="form-hint" [id]="'hintid-' + id()">{{ hintAfter() }}</p>
  }

  @if (showValidationMessages()) {
    <ds-field-error-message [id]="'errorid-' + id()" [errors]="errors()" [label]="label()" />
  }
</div>
